export default __webpack_public_path__ + "static/media/mm.7cabc42b.svg";